import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import HttpService from '@/http';
import router from '@/router';

export const useAuthStore = defineStore('auth', () => {
    const token = ref(localStorage.getItem('jwt_token') || null);
    const user = ref(JSON.parse(localStorage.getItem('user')) || null);
    const loading = ref(false);
    const error = ref(null);
    const loginAttemptInProgress = ref(false);

    const isAuthenticated = computed(() => {
        const hasToken = !!token.value;
        const hasUser = !!user.value;
        return hasToken && hasUser;
    });
    
    const isAdmin = computed(() => user.value?.role === 'admin');

    const login = async (credentials) => {
        if (loginAttemptInProgress.value) {
            return { success: false, error: 'Login già in corso' };
        }
        
        loginAttemptInProgress.value = true;
        loading.value = true;
        error.value = null;
        
        try {
            const response = await HttpService.post('/auth/login', credentials, { skipAuth: true });
            
            if (response.success && response.data?.result) {
                // Salva prima il token
                const newToken = response.data.result.token;
                const userData = response.data.result.user;
                
                // Salva in localStorage
                localStorage.setItem('jwt_token', newToken);
                localStorage.setItem('user', JSON.stringify(userData));
                
                // Poi aggiorna lo stato
                token.value = newToken;
                user.value = userData;
                
                
                return { success: true };
            }
            
            error.value = response.error || 'Login fallito';
            return { success: false, error: error.value };
        } catch (err) {
            console.error('Errore durante il login:', err);
            error.value = err.error || err.message;
            return { success: false, error: error.value };
        } finally {
            loading.value = false;
            loginAttemptInProgress.value = false;
        }
    };

    const logout = () => {
        const currentPath = window.location.pathname;
        if (currentPath.includes('/login')) {
            return;
        }
        
        // Rimuovi dati dal localStorage
        localStorage.removeItem('jwt_token');
        localStorage.removeItem('user');
        
        // Poi aggiorna lo stato
        token.value = null;
        user.value = null;
        
        
        // Reindirizza alla pagina di login
        if (!currentPath.includes('/login')) {
            router.push('/login');
        }
    };

    const getUser = computed(() => user.value);
    const getToken = computed(() => token.value);

    return {
        token,
        user,
        loading,
        error,
        isAuthenticated,
        isAdmin,
        login,
        logout,
        getUser,
        getToken
    };
}); 